<div class="row justify-content-between justify-content-md-start">
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Traffic with IDFA/IDFV Flags %"
        tooltipValue="Percentage of traffic with IDFA or IDFV identifiers present over the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.identifiedTrafficRate | perc:'1.2-2'}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="CTR (Click-Through Rate)"
        tooltipValue="Percent of mobile ad impressions that were clicked in the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.ctr | perc:'1.2-2'}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Native % : Interstitial %"
        tooltipValue="Ratio of native to interstitial ad formats on mobile in the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.nativeVsInterstitialRatio | ratio}}
    </h3>
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Ad View Time"
        tooltipValue="Average viewable time per mobile ad in the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.adViewTime | duration: 'ms':'mmss'}}
    </h3>
  </div>
</div>